export default {
  footerLink: 'Impostazioni dei cookie',
  consentModal: {
    title: 'Utilizziamo i cookie',
    description: 'Utilizziamo un set minimo di cookie per il funzionamento del sito, oltre a cookie opzionali per analisi e pubblicità — solo con il tuo consenso.',
    acceptAllBtn: 'Accetta tutti',
    acceptNecessaryBtn: 'Rifiuta tutti',
    showPreferencesBtn: 'Gestisci preferenze',
  },
  preferencesModal: {
    title: 'Preferenze dei cookie',
    acceptAllBtn: 'Accetta tutti',
    acceptNecessaryBtn: 'Rifiuta tutti',
    savePreferencesBtn: 'Salva preferenze',
    closeIconLabel: 'Chiudi',
    sections: [
      {
        title: 'Necessari',
        description: 'Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati.',
        linkedCategory: 'necessary',
      },
      {
        title: 'Analisi',
        description: 'Ci aiutano a capire come viene utilizzato il sito così possiamo migliorarlo.',
        linkedCategory: 'analytics',
      },
      {
        title: 'Pubblicità',
        description: 'Utilizzati per rendere gli annunci più rilevanti. Attivi solo con il tuo consenso.',
        linkedCategory: 'ads',
      },
    ],
  },
}
